export default {
  INIT: 'INIT',
  PENDING: 'PENDING',
  SUCCESSFULLY: 'SUCCESSFULLY',
  FAILED: 'FAILED',
};
